import {Button, Paper, Alert, Flex, Space} from "@mantine/core";
import { DiscordLogo as IconBrandDiscord } from "@phosphor-icons/react";
import {useNavigate} from "react-router";
import {Row, Col} from "../../components/Flex/Flex"
import Page from "../../components/Page/Page.tsx";
import {useUser} from "../../utils/api";
import FeatureList from "../meta/FeatureList.jsx";

export default function LandingPage() {
    const {user} = useUser();
    const navigate = useNavigate();

    return (
        <Page>
            <h1 className="text-center">Welcome to the Forge!</h1>
            {user.subLevel === 0 ? (
            <Paper style={{margin: '1rem', padding: '0.5rem 1rem'}}>
                <Row align="center" wrap={false} mobileCol={true}>
                    <Col><img src="/logo-100.png" width={40} height={40} alt="The Forge"/></Col>
                    <Col grow={1}><p>Subscribe now to unlock exclusive tools without limitations, increasing your efficiency! <span style={{color: 'var(--mantine-color-forge-5)', cursor: 'pointer'}} onClick={() => navigate('/subscribe/pricing')}>Discover pricing and features</span> </p></Col>
                    <Col shrink={0}><Button onClick={() => navigate('/subscribe')}>Subscribe Now</Button></Col>
                </Row>
            </Paper>
            ) : null}

            <Flex justify="center">
                <a target="_blank" href="https://discord.gg/RMqSr75qUv" style={{textDecoration: 'none'}} rel="noreferrer"><Alert icon={<IconBrandDiscord size={16}/>} color="blue">Join us in our Discord server: https://discord.gg/RMqSr75qUv</Alert></a>
            </Flex>

            <Space h="xl" />

            <FeatureList />

        </Page>
    )
}
